module.exports = __webpack_public_path__ + "palo-bangla-bb996cdb70d2e0ccec8c.svg";